import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e9abfeb"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Refill Stamina ")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hound-card__img" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hound-card__img__armor" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hound-card__img__neon" }, null, -1))
const _hoisted_5 = { class: "hound-card__info" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background-color":"var(--primary-color)","height":"2rem"} }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background-color":"var(--secondary-accent)","height":"2rem"} }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background-color":"var(--info-color)","height":"2rem"} }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background-color":"var(--error-color)","height":"2rem"} }, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Stamina")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("FILL")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" You can ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"var(--secondary-accent)"} }, "replenish", -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode()
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" of your stamina without paying any fees. ")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" If you ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("refill")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(", this replenished stamina will be added automatically. ")
const _hoisted_20 = { style: {"margin-right":"2rem"} }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Refill Fee:")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "USD", -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode("REPLENISH")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("REFILL")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_text = _resolveComponent("n-text")!
  const _component_n_h4 = _resolveComponent("n-h4")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_card = _resolveComponent("n-card")!
  const _component_n_h3 = _resolveComponent("n-h3")!
  const _component_n_el = _resolveComponent("n-el")!
  const _component_n_input_number = _resolveComponent("n-input-number")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_n_form = _resolveComponent("n-form")!

  return (_openBlock(), _createBlock(_component_n_form, {
    model: _ctx.formValue,
    ref: "formRef",
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.refillStamina()), ["prevent"])),
    rules: _ctx.rules
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_card, {
        segmented: {
        footer: 'soft',
        content: true
      },
        role: "modal",
        closable: "",
        onClose: _ctx.cancel
      }, {
        header: _withCtx(() => [
          _hoisted_1
        ]),
        action: _withCtx(() => [
          _createVNode(_component_n_space, {
            align: "center",
            justify: "space-between"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_n_space, {
                    align: "center",
                    size: _ctx.exchangeRatesAvailable && _ctx.exchangeRates[_ctx.staminaRefillCurrency] ? 'medium' : [4, 4]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_text, null, {
                        default: _withCtx(() => [
                          _hoisted_21
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_n_space, {
                        vertical: "",
                        size: [1, 1]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_n_text, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.formatNumberDecimals(_ctx.formValue.unitsToRefill * Number(_ctx.eth.utils.formatEther(_ctx.staminaRefill1x)))) + " ", 1),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.currencyName), 1)
                            ]),
                            _: 1
                          }),
                          (_ctx.exchangeRatesAvailable && _ctx.exchangeRates[_ctx.staminaRefillCurrency])
                            ? (_openBlock(), _createBlock(_component_n_text, {
                                key: 0,
                                depth: "3"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.convertToUSD(_ctx.formatNumberDecimals(_ctx.formValue.unitsToRefill * Number(_ctx.eth.utils.formatEther(_ctx.staminaRefill1x))), false, _ctx.staminaRefillCurrency)) + " ", 1),
                                  _hoisted_22
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["size"])
                ])
              ]),
              _createVNode(_component_n_space, { justify: "right" }, {
                default: _withCtx(() => [
                  (_ctx.refreshedStamina)
                    ? (_openBlock(), _createBlock(_component_n_button, {
                        key: 0,
                        disabled: _ctx.loading || _ctx.replenishLoading,
                        loading: _ctx.replenishLoading,
                        onClick: _ctx.replenishStamina,
                        ghost: "",
                        style: {"background-color":"var(--secondary-accent)","color":"#fff"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_23
                        ]),
                        _: 1
                      }, 8, ["disabled", "loading", "onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_n_button, {
                    disabled: _ctx.loading || _ctx.replenishLoading || !_ctx.actualUnitsUntilFull,
                    type: "primary",
                    "attr-type": "submit",
                    loading: _ctx.loading
                  }, {
                    default: _withCtx(() => [
                      _hoisted_24
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_n_space, { vertical: "" }, {
            default: _withCtx(() => [
              (_ctx.hound)
                ? (_openBlock(), _createBlock(_component_n_card, {
                    key: 0,
                    style: {"margin-top":"1rem"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["hound-card avatar", `
              avatar-component-${_ctx.hound.extensionTraits ? _ctx.hound.extensionTraits : _ctx.hound.head[3]}-${_ctx.hound.color[3]}
              avatar-neon-${_ctx.hound.extensionTraits ? _ctx.hound.extensionTraits : _ctx.hound.head[3]}-${_ctx.hound.color[2]}
            `])
                      }, [
                        _createElementVNode("div", null, [
                          _hoisted_2,
                          _hoisted_3,
                          _hoisted_4,
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_n_h4, { style: {"margin-bottom":"0"} }, {
                              default: _withCtx(() => [
                                _createVNode(_component_n_text, { type: "primary" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.hound.name), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createVNode(_component_n_space, { justify: "right" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_n_text, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.hound.sex), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ], 2)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_n_el, { style: {"margin-top":"1rem"} }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    style: _normalizeStyle([{"display":"grid","width":"100%","border-radius":"3px","overflow":"hidden","position":"relative"}, {
              gridTemplateColumns: `${(_ctx.hound.stamina / _ctx.staminaCap) * 100}% ${_ctx.refreshedStamina}% ${(_ctx.formValue.unitsToRefill / _ctx.staminaCap) * 100}% auto`
            }])
                  }, [
                    _hoisted_6,
                    _hoisted_7,
                    _hoisted_8,
                    _hoisted_9,
                    _createVNode(_component_n_h3, { style: {"position":"absolute","top":"0","color":"var(--color-modal)","text-align":"center","margin":"0","padding":"0","width":"100%"} }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    })
                  ], 4)
                ]),
                _: 1
              }),
              (_ctx.actualUnitsUntilFull)
                ? (_openBlock(), _createBlock(_component_n_form_item, {
                    key: 1,
                    path: "unitsToRefill",
                    label: "Units to refill",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_input_number, {
                        disabled: _ctx.loading || _ctx.replenishLoading,
                        value: _ctx.formValue.unitsToRefill,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formValue.unitsToRefill) = $event)),
                        step: 1,
                        min: 1,
                        max: _ctx.actualUnitsUntilFull,
                        style: {"width":"100%"}
                      }, null, 8, ["disabled", "value", "max"]),
                      _createVNode(_component_n_button, {
                        disabled: _ctx.loading || _ctx.replenishLoading,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.formValue.unitsToRefill=_ctx.actualUnitsUntilFull))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.refreshedStamina)
                ? (_openBlock(), _createBlock(_component_n_alert, { key: 2 }, {
                    default: _withCtx(() => [
                      _hoisted_12,
                      _hoisted_13,
                      _hoisted_14,
                      _createElementVNode("strong", null, _toDisplayString(_ctx.refreshedStamina) + "%", 1),
                      _hoisted_15,
                      _hoisted_16,
                      _hoisted_17,
                      _createVNode(_component_n_text, { type: "primary" }, {
                        default: _withCtx(() => [
                          _hoisted_18
                        ]),
                        _: 1
                      }),
                      _hoisted_19
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClose"])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}